import _ from "underscore";
import { productCategoryToSizePlaceHolderMapper } from "rtr-constants";

var ProductCollectionHelpers = {
  getProducts: function (list, listAccess) {
    if (_.isArray(listAccess)) {
      var lists = _.extend({}, list);
      return _.reduce(
        listAccess,
        function (memo, key) {
          return memo[key];
        },
        lists
      );
    } else {
      return list[listAccess];
    }
  },

  getSizesPlaceholder: function (product = {}, defaultEmptySizeString = false, allSizesUnavailable = false) {
    const categoryId = product.category?.id;

    let defaultSizeString;
    if (defaultEmptySizeString) {
      defaultSizeString = "";
    } else if (allSizesUnavailable) {
      defaultSizeString = "All sizes unavailable";
    } else {
      defaultSizeString = "Size";
    }

    if (!categoryId) {
      return defaultSizeString;
    }

    const placeholder = productCategoryToSizePlaceHolderMapper[categoryId];
    return placeholder ? placeholder : defaultSizeString;
  },

  sortKeys: {
    stylist: {
      listAccess: "productRecos",
      displayName: "We love!",
    },
    topRentals: {
      listAccess: "productCollectionMembers",
      displayName: "Top Rentals",
    },
    wlm: {
      listAccess: ["eventType", "productRecos"],
      displayName: "Stylist Picks",
    },
    theDate: {
      listAccess: ["eventDate", "productRecos"],
      displayName: "The Date",
    },
  },
};

export default ProductCollectionHelpers;

export const { getProducts, getSizesPlaceholder, sortKeys } = ProductCollectionHelpers;
